import { COLORS } from '@btime/constants'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useNavigation } from '../../../utils/contexts/NavigationContext'
import { usePlaceTypesWithPermission } from '../../../utils/helpers/placeTypes'
import AbsolutePageTemplate from '../AbsolutePageTemplate'
import Container from '../../structure/Container'
import FlexGrid from '../../structure/FlexGrid'
import Link from '../../actions/Link'
import List from '../../list/List'
import ListGroup from '../../list/ListGroup'
import ListItemWrapper from '../../list/ListItemWrapper'
import PageHeaderPanel from '../../presentation/PageHeaderPanel'
import Panel from '../../../packages/kiti/components/structure/Panel'
import Sticky from '../../helpers/Sticky'
import Text from '../../../packages/kiti/components/presentation/Text'

const MenuItem = ({ link, title }) => {
  const navigate = useNavigation()
  const path = document.location.pathname

  const isSelected = link === path

  return (
    <Link onClick={() => navigate(link)} block>
      <ListItemWrapper rightBorderColor={isSelected && COLORS.darkPurple}>
        <Text color={isSelected ? COLORS.darkPurple : COLORS.dark3} bold={isSelected}>
          {title}
        </Text>
      </ListItemWrapper>
    </Link>
  )
}

const SimpleCrudsTemplate = ({ children }) => {
  const { t } = useTranslation(['common', 'components', 'checklists'])
  const navigate = useNavigation()
  const canSetupServiceOrder = useSessionPermission('setupServiceOrder')
  const canSetupUser = useSessionPermission('setupUser')
  const canSetupChecklist = useSessionPermission('setupChecklist')
  const canCreateGroup = useSessionPermission('createUserGroup')
  const canSetupAsset = useSessionPermission('setupAsset')

  const types = usePlaceTypesWithPermission('setup')

  return (
    <AbsolutePageTemplate>
      <PageHeaderPanel
        leftIcon="BsArrowLeftShort"
        leftAction={() => navigate(-1)}
        title={t('components:generalRegistrations')}
        mediumPadding
        noContainer
      />

      <FlexGrid align="stretch">
        <Panel flex={1} margin={0.6} noPadding>
          <Sticky>
            {canSetupServiceOrder && (
              <ListGroup title={t('common:activities')} key="atividades">
                <List noBorder>
                  <MenuItem link="/minicruds/pending" title={t('components:pendingTypes')} />
                  <MenuItem link="/minicruds/approved" title={t('components:approvalReasons')} />
                  <MenuItem link="/minicruds/disapproved" title={t('components:disapprovalReasons')} />
                  <MenuItem link="/minicruds/unproductive" title={t('components:unproductiveReasons')} />
                  <MenuItem link="/minicruds/canceled" title={t('components:cancellationReasons')} />
                  <MenuItem link="/minicruds/pause" title={t('components:pauseReasons')} />
                </List>
              </ListGroup>
            )}

            {canSetupUser && canCreateGroup && (
              <ListGroup title={t('common:users')} key="usuarios">
                <List noBorder>
                  <MenuItem link="/groups" title={t('components:userGroups')} />
                </List>
              </ListGroup>
            )}

            {canSetupAsset && (
              <ListGroup title={t('common:asset')} key="asset">
                <List noBorder>
                  <MenuItem link="/minicruds/assetType" title={t('components:assetTypes')} />
                </List>
              </ListGroup>
            )}

            {canSetupChecklist && (
              <ListGroup title={t('checklists:checklist')} key="checklist">
                <List noBorder>
                  <MenuItem link="/minicruds/checkListCategory" title={t('components:checklistCategories')} />
                </List>
              </ListGroup>
            )}

            {types.map(type => (
              <ListGroup key={type.key} title={type.name}>
                <List noBorder>
                  <MenuItem link={`/place-levels/${type.key}`} title={t('components:levelsOf', { name: type.name })} />
                </List>
              </ListGroup>
            ))}
          </Sticky>
        </Panel>
        <Panel flex={3} margin={0.6}>
          <div>
            <Container>{children}</Container>
          </div>
        </Panel>
      </FlexGrid>
    </AbsolutePageTemplate>
  )
}

export default SimpleCrudsTemplate
